import { useQuery } from '@tanstack/react-query';
import { fetchDealerFundStatement } from '../services/dealerFundStatement';
import { dealerKeys } from './useDealersQuery';

export function useDealerFundStatementQuery(dealerId: string, page: number, perPage: number, enabled: boolean) {
    return useQuery({
        queryKey: dealerKeys.fundStatement(dealerId, page, perPage),
        queryFn: () => fetchDealerFundStatement(dealerId, page, perPage),
        enabled: !!dealerId && enabled,
        retry: false,
        refetchOnWindowFocus: false,
        staleTime: 30_000,
        // Holds the previous page during a page change only; another dealer's figures never stand in.
        placeholderData: (previous, previousQuery) => (previousQuery?.queryKey[1] === dealerId ? previous : undefined),
    });
}
